import { render, staticRenderFns } from "./ApiPrueba.vue?vue&type=template&id=2c489886&"
import script from "./ApiPrueba.vue?vue&type=script&lang=js&"
export * from "./ApiPrueba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports